@use '../@shared/global' as *;
@use '../@shared/alert.mixin' as *;
@use '../@shared/form-field.mixin' as *;
@use '../@shared/input-container.mixin' as *;
@use '../@shared/input.mixin' as *;
@use '../@shared/mixins' as *;

@layer kol-component {
	@include kol-alert;
	@include kol-form-field;
	@include kol-input-container;
	@include kol-input;
	.kol-input-color {
		&__input {
			&--color {
				flex-grow: 1;
			}

			&--text {
				width: to-rem(112);
			}
		}

		&__inputs-wrapper {
			display: flex;
			flex-direction: row;
			align-items: center;
		}
	}

	.kol-input {
		cursor: pointer;

		&:disabled {
			cursor: not-allowed;
		}
	}
}
